import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { withSwal } from "react-sweetalert2";
import "../../../App.css";
import "../../../assets/css/AdminStyles.css";
import "../../../assets/css/fontStyle.css";

import axios from "axios";
import {
  FaCalendarCheck,
  FaCalendarDay,
  FaRegCalendarCheck,
  FaRegCalendarPlus,
} from "react-icons/fa6";
import { MdMiscellaneousServices, MdOutlineInventory2 } from "react-icons/md";
import { BiCategory } from "react-icons/bi";
import { TbBrandCodesandbox } from "react-icons/tb";

import { scrollToTop } from "../../../helper/HelperFunctions";
import MasterLayout from "../master/MasterLayout";
import AppContext from "../../../context/AppContext";
import { form } from "framer-motion/client";

const Dashboard = ({ swal }) => {
  const { baseUrl } = useContext(AppContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loggedInAdmin, setLoggedInAdmin] = useState();
  const [totalBrands, setTotalBrands] = useState(0);
  const [totalCategories, setTotalCategories] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [upcomingAppointments, setUpcomingAppointments] = useState(0);
  const [completedAppointments, setCompletedAppointments] = useState(0);
  const [access_token, setAccessToken] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [deviceModel, setDeviceModel] = useState("");
  const [problem, setProblem] = useState("");
  const [errorMessages, setErrorMessages] = useState("");
  const [walkinInCustomerAddLoading, setWalkinInCustomerAddLoading] = useState(
    false
  );

  const getDashboardStats = (accessToken) => {
    axios
      .get("https://admin.fixtechexperts.co.uk/api/dashboard/dashboardStats", {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((resp) => {
        console.log(resp.data);
        setTotalBrands(resp.data.totalBrands);
        setTotalCategories(resp.data.totalCategories);
        setTotalProducts(resp.data.totalProducts);
        setUpcomingAppointments(resp.data.totalUpcomingAppointments);
        setCompletedAppointments(resp.data.totalCompletedAppointments);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const submitWalkinCustomer = (accessToken) => {
    // setWalkinInCustomerAddLoading(true);
    
    const formData = new FormData();
    formData.append("customerName",customerName);
    formData.append("customerPhone",customerPhone);
    formData.append("customerEmail",customerEmail);
    formData.append("deviceModel",deviceModel);
    formData.append("problem",problem);
    formData.append("status","ongoing");


    axios.post(`${baseUrl}/api/dashboard/addWalkInCustomer`,formData,{
      headers:{
        Authorization: "Bearer " + access_token,
        "Content-Type":"multipart/form-data"

      }
    }).then((response) => {
        console.log(response.data);
        if(response.data.added == "yes")
        {
          swal.fire({
            title: "Welldone!",
            text: "Another Customer Added.",
            icon: "success",
          });
        }else
        {
          swal.fire({
            title: "Welldone!",
            text: "Error in adding customer.",
            icon: "error",
          });
        }
    })

  };

  // const submitWalkinCustomer = (accessToken) => {
  //   const formData = new FormData();
  //   formData.append("name", `${customerName}`);
  //   formData.append("email", `${customerPhone}`);
  //   formData.append("phone", `${customerEmail}`);
  //   formData.append("device", `${deviceModel}`);
  //   formData.append("problem", `${problem}`);

  //   axios
  //     .post(`${baseUrl}/api/dashboard/addWalkInCustomer`, formData, {
  //       headers: {
  //         Authorization: "Bearer " + accessToken,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     })
  //     .then((response) => {
  //       setAddBrandLoading(false);
  //       if (response.data.success == "yes") {
  //         swal.fire({
  //           title: "Welldone!",
  //           text: "Another Brand Added to Shop.",
  //           icon: "success",
  //         });
  //       } else {
  //         swal.fire({
  //           title: "Sorry!",
  //           text: "Unable to add another Brand.",
  //           icon: "error",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       setAddBrandLoading(false);
  //       // setErrorMessages(err.response.data.error);
  //       // setLoading(false);
  //     });
  // };

  useEffect(() => {
    scrollToTop();
    setTimeout(() => {
      if (localStorage.getItem("admin") == null) {
        navigate("/");
      } else {
        setLoggedInAdmin(JSON.parse(localStorage.getItem("admin")));
        const admin = JSON.parse(localStorage.getItem("admin"));
        console.log(admin.access_token);
        getDashboardStats(admin.access_token);
        setAccessToken(admin.access_token);
        setLoading(false);
      }
    }, 1000);
  }, []);

  return loading ? (
    <Row className="d-flex justify-content-lg-center">
      <Spinner style={{ width: "50px", height: "50px", marginTop: "20%" }} />
    </Row>
  ) : (
    <MasterLayout>
      <Container className="m-0 p-0 " fluid>
        <h3 className="poppins-bold Heading-Text mt-5">Dashboard</h3>

        <Row className="px-2">
          <Col lg={6} md={6} sm={12} className="py-3">
            <Card className="p-3 dashboard-card">
              <Container className="m-0 p-0">
                <h6 className="poppins-medium">Total Brands</h6>
                <h5 className="poppins-semiBold mt-4">{totalBrands}</h5>
              </Container>
              <TbBrandCodesandbox size={35} className="Heading-Text" />
            </Card>
          </Col>

          <Col lg={6} md={6} sm={12} className="py-3">
            <Card className="p-3 dashboard-card">
              <Container className="m-0 p-0">
                <h6 className="poppins-medium">Total Categories</h6>
                <h5 className="poppins-semiBold mt-4">{totalCategories}</h5>
              </Container>
              <BiCategory size={35} className="Heading-Text" />
            </Card>
          </Col>

          <Col lg={6} md={6} sm={12} className="py-3">
            <Card className="p-3 dashboard-card">
              <Container className="m-0 p-0">
                <h6 className="poppins-medium">Total Products</h6>
                <h5 className="poppins-semiBold mt-4">{totalProducts}</h5>
              </Container>
              <MdOutlineInventory2 size={35} className="Heading-Text" />
            </Card>
          </Col>

          <Col lg={6} md={6} sm={12} className="py-3">
            <Card className="p-3 dashboard-card">
              <Container className="m-0 p-0">
                <h6 className="poppins-medium">Completed Appointments</h6>
                <h5 className="poppins-semiBold mt-2">
                  {completedAppointments}
                </h5>
              </Container>
              <FaRegCalendarCheck size={20} className="Heading-Text" />
            </Card>
          </Col>
          <Col lg={6} md={6} sm={12} className="py-3">
            <Card className="p-3 dashboard-card">
              <Container className="m-0 p-0">
                <h6 className="poppins-medium">Upcoming Appointments</h6>
                <h5 className="poppins-semiBold mt-2">
                  {upcomingAppointments}
                </h5>
              </Container>
              <FaRegCalendarPlus size={20} className="Heading-Text" />
            </Card>
          </Col>
        </Row>

        <h3 className="poppins-bold Heading-Text mt-5">Walk-In Customer</h3>

        <Row className="px-2">
          <Col lg={6} md={6} sm={12} className="py-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                className="poppins-regular"
                type="text"
                placeholder="Customer Name"
                size="lg"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} className="py-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                className="poppins-regular"
                type="phone"
                placeholder="Customer Phone"
                size="lg"
                value={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} className="py-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                className="poppins-regular"
                type="email"
                placeholder="Customer Email"
                size="lg"
                value={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} className="py-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                className="poppins-regular"
                type="text"
                placeholder="Device Model"
                size="lg"
                value={deviceModel}
                onChange={(e) => setDeviceModel(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} className="py-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                className="poppins-regular"
                type="text"
                placeholder="Device Problem"
                size="lg"
                value={problem}
                onChange={(e) => setProblem(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={12} md={12} sm={12} className="py-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              {walkinInCustomerAddLoading == true ? (
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <Spinner size="sm" />
                </div>
              ) : (
                <Button
                  onClick={() => {
                    // if (customerName == "") {
                    //   setErrorMessages("Name required");
                    // } else if (customerEmail == "") {
                    //   setErrorMessages("Email required");
                    // } else if (customerPhone == "") {
                    //   setErrorMessages("Phone required");
                    // } else if (deviceModel == "") {
                    //   setErrorMessages("Device Model required");
                    // } else if (problem == "") {
                    //   setErrorMessages("Problem required");
                    // } else {
                      submitWalkinCustomer();
                    // }
                  }}
                  type="submit"
                  variant="outline-dark"
                  size="md"
                  className="poppins-semiBold  mt-4 mx-3"
                  style={{ width: "90%" }}
                >
                  Add New Walk-In Customer
                </Button>
              )}
            </Form.Group>
          </Col>
          {errorMessages != "" ? (
            <ToastContainer
              position="bottom-end"
              className="p-3"
              style={{ zIndex: 1 }}
            >
              <Toast
                bg="danger"
                onClose={() => {
                  setErrorMessages("");
                }}
                show={errorMessages == "" ? false : true}
                animation={true}
              >
                <Toast.Header>
                  <strong className="me-auto poppins-bold">IMPORTANT</strong>
                </Toast.Header>
                <Toast.Body className="poppins-regular text-light">
                  {errorMessages}
                </Toast.Body>
              </Toast>
            </ToastContainer>
          ) : (
            <p></p>
          )}
        </Row>
      </Container>
    </MasterLayout>
  );
};

export default withSwal(Dashboard);
